// トップスライダーの起動 // Launch the top slider
const swiper = new Swiper(".js-top-slider", {
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 2000,
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
});


const partnerSwiper = new Swiper(".js-top-partner-slider", {
  loop: true,
  slidesPerView: 'auto', 
  speed: 6000, 
  spaceBetween: 20,
  allowTouchMove: false, 
  autoplay: {
    delay: 0, 
  },
});
